import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./redux/internal";
import { AuthVerify } from "./components/authentication/AuthVerify";

import "./index.css";
import "./i18n";
import WrappedApp from "./App";
import { MomentWrapper } from "./MomentWrapper";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <MomentWrapper>
        <WrappedApp />
        <AuthVerify />
      </MomentWrapper>
    </BrowserRouter>
  </Provider>,
);
